import { useNavigate, useParams } from 'react-router-dom';

import { Button, Modal } from 'antd';
import useMessage from 'antd/es/message/useMessage';

import { enStatus } from '@/interfaces/course';
import { TermProps, enTermOrigin } from '@/interfaces/term';
import { coursesApi, useAcceptTermMutation, useGetCourseQuery } from '@/services/course';
import { lessonsApi } from '@/services/lesson';
import styled, { StyledProp } from '@/styled';

const CourseTerm = (props: TermProps & StyledProp) => {
  const { hash } = useParams();
  const [message] = useMessage();
  const { data, refetch } = useGetCourseQuery(hash);
  const [fetchModules] = coursesApi.endpoints.getModules.useLazyQuery();
  const [fetchLesson] = lessonsApi.endpoints.getLessons.useLazyQuery();
  const fetchMap = {
    [enTermOrigin.course]: () => fetchModules({ courseHash: hash }),
    [enTermOrigin.lesson]: () => fetchLesson(props.lessonId)
  };

  const navigate = useNavigate();
  const [saveDecision, { isLoading }] = useAcceptTermMutation();

  const acceptTerm = () => {
    saveDecision({ courseHash: hash, accepted: true })
      .unwrap()
      .then(() => {
        refetch();
        fetchMap[props.origin]();
      })
      .catch(() => {
        message.error('Erro ao aceitar os termos!');
      });
  };

  const refuseTerm = () => {
    saveDecision({ courseHash: hash, accepted: false });
    navigate('/resumo');
  };

  return (
    <Modal
      aria-label='Termos de aceite do curso'
      open={data?.status === enStatus.MUST_ACCEPT_TERM}
      title='Termos e condições de Uso'
      closable={false}
      footer={
        <>
          <Button type='text' onClick={refuseTerm} disabled={isLoading}>
            Discordo
          </Button>
          <Button type='primary' onClick={acceptTerm} loading={isLoading}>
            Concordo
          </Button>
        </>
      }
    >
      <div className={props.className} dangerouslySetInnerHTML={{ __html: data?.terms_content }} />
    </Modal>
  );
};
export default styled(CourseTerm)`
  background: ${({ theme }) => theme.palette.gray[9]};
  padding: ${({ theme }) => theme.space.pxToRem(16)};
  p {
    margin: 0;
    padding: 0;
  }
`;
